import { SET_USER_COMPANIES } from '../../consts/action-types';
import { Action } from './types/Action';
import { UserCompaniesReduxState } from './types/UserCompaniesReduxState';

export const initialState: UserCompaniesReduxState = {
  current: null,
  companies: []
};

export default function (state = initialState, action: Action) {
  switch (action.type) {
    case SET_USER_COMPANIES: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
